export default __webpack_public_path__ + "static/media/CARTA_DE_RESIDENCIA_2024.0df261f0.pdf";